import { render, staticRenderFns } from "./ActionBtns.vue?vue&type=template&id=0b215516&scoped=true&"
import script from "./ActionBtns.vue?vue&type=script&lang=js&"
export * from "./ActionBtns.vue?vue&type=script&lang=js&"
import style0 from "./ActionBtns.vue?vue&type=style&index=0&id=0b215516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b215516",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
